export default __webpack_public_path__ + "3b4926d4715d4c9bdf4e24e407a5002b.png";